import { Field, Int } from '@nestjs/graphql'
import { ObjectType } from '@nestjs/graphql'

@ObjectType()
export class PenNameFollowerDto {
  @Field(t => Int)
  id!: number
}
